import { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useAuthMutation } from '../../Api/authentication';
import { useGlobalState } from '../../App/globalState';
import { formatPhoneNumber } from '../../Helpers/phone-formatter';
import useTranslate from '../../Hooks/useTranslate';
import Button from '../../Style-guide/Button';
import Input from '../../Style-guide/Input';
import Text from '../../Style-guide/Text';
import Title from '../../Style-guide/Title';
import { validate } from '../SignUp/validator';
import SignInWrapper from './style/signInWrapper';

const SignIn = () => {
  const { mutate: signInRequest, isSuccess, data } = useAuthMutation();
  const { updateGlobalState } = useGlobalState();
  const navigate = useNavigate();
  const location = useLocation();
  const { redirectPath } = location.state || {};

  const tr = useTranslate();

  const [formData, setFormData] = useState({
    phone: '',
    password: '',
  });

  const [errors, setErrors] = useState({
    phone: '',
    password: '',
  });

  useEffect(() => {
    if (isSuccess && data) {
      const { user } = data;
      updateGlobalState({ user: { ...user } });
      if (redirectPath) {
        navigate(redirectPath);

        return;
      }
      navigate('/');
    }
    // Disabled to prevent infinite useEffect caused by updateGlobalState dependency
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data, isSuccess]);

  const handleChange = (e) => {
    const { name } = e.target;
    let { value } = e.target;

    if (name === 'phone') {
      value = formatPhoneNumber(value);
    }

    const validated = validate(name, value);

    if (!validated.isValid) {
      // setErrors({ ...errors, [name]: validated.message });
      setErrors({
        ...errors,
        [name]: tr(validated.translationKey, { isError: true }) || validated.message,
      });
    } else {
      setErrors({ ...errors, [name]: '' });
    }

    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const noErrors = !Object.entries(errors).some((item) => item[1]?.length);
    const noEmptyFields = !Object.entries(formData).some((item) => !item[1]?.length);
    const isValid = noErrors && noEmptyFields;

    if (isValid) {
      signInRequest({ data: formData });
    }
  };

  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      handleSubmit(event);
    }
  };

  return (
    <SignInWrapper>
      <Title size='MD' className='page-title'>
        {tr('sign_in')}
      </Title>

      <form
        onSubmit={handleSubmit}
        onKeyDown={handleKeyDown}
        className='inputs-container'
      >
        <Input
          value={formData.phone}
          error={errors.phone}
          type='tel'
          className='field'
          label={tr('phone_number')}
          name='phone'
          onChange={handleChange}
          autoComplete='off'
        />
        <Input
          value={formData.password}
          error={errors.password}
          type='password'
          className='field'
          label={tr('password')}
          name='password'
          onChange={handleChange}
          autoComplete='off'
        />
        <Button type='submit' className='submit-btn'>
          {tr('sign_in')}
        </Button>
      </form>

      <Text size='SM' className='register-redirection-text'>
        {tr('do_not_have_account')}
        <Link to='/signup' className='link-to-sign-up'>
          {tr('sign_up')}
        </Link>
      </Text>
    </SignInWrapper>
  );
};

export default SignIn;
